import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import * as Sentry from '@sentry/react'
import App from './App.jsx'
import { Provider } from './components/ui/provider.jsx'
import 'driver.js/dist/driver.css'
import './styles/tour-overrides.css'

const isDevOrProd = window.location.hostname.includes('cadencya.com')
const isDevHost = window.location.hostname.includes('dev.')
const cookieConsent = (() => {
  try {
    const raw = localStorage.getItem('cadencya_cookie_consent')
    return raw ? JSON.parse(raw) : null
  } catch { return null }
})()
const hasAnalyticsConsent = cookieConsent?.analytics === true
const sentryDsn = isDevHost
  ? 'https://9a2aec230ff649c7b7df3e76f1fcbcd8@sentry.dev.cadencya.com/1'
  : import.meta.env.VITE_SENTRY_DSN

if (isDevOrProd && hasAnalyticsConsent && sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: isDevHost ? 'development' : 'production',
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    tracesSampleRate: 1.0,
    autoSessionTracking: false,
    enableLogs: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
    ],
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider>
        <App />
      </Provider>
    </HelmetProvider>
  </React.StrictMode>,
)
